/**
 * 크기가 정해진 표(첫 줄 모든 칸에 폭이 있는 표)를 편집기 안에서 **비율로** 그린다 — 규칙은 utils/tableWidth.ts,
 * 배선은 utils/tableWidthLexical.ts 의 registerTableWidthStyling.
 *
 * 편집 모드만이 아니라 [보기](읽기 전용) 편집기에도 있어야 한다. 그래서 표 손잡이처럼 [Insert] 메뉴
 * (편집 모드에만 뜬다)에 두지 않고 공용 Editor 에 둔다.
 *
 * Lexical 은 칸 DOM 을 폭이 바뀔 때마다 새로 만들며 px 폭을 다시 쓴다(TableCellNode.updateDOM).
 * 그래서 표·줄·칸이 바뀔 때마다(mutation) 다시 입힌다. 같은 값이면 쓰지 않는다.
 * Lexical 의 DOM 감시는 속성(style)을 보지 않으므로(observerOptions: characterData·childList·subtree)
 * 여기서 style 을 바꿔도 편집기 상태와 부딪히지 않는다.
 */
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

import { registerTableWidthStyling } from '../utils/tableWidthLexical';

export default function TableWidthPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => registerTableWidthStyling(editor), [editor]);

  return null;
}
